import React, { ReactNode } from 'react';
import cx from 'clsx';
import Select from 'antd/es/select';

import { IconRcDropdown } from 'assets';
import { IconwarnMark } from '@/assets/vote';
import { HelperTooltip } from '@/components';

import style from './index.module.css';

type Props = {
  selectOptions: { mode: string; label: string | JSX.Element; disabledTip?: ReactNode }[];
  setSelect?: Function;
  select?: string;
  onSelect?: (val: string) => void;
  width?: number | string;
  className?: string;
  dropdownClassName?: string;
  isDarkColor?: boolean;
  height?: number | string;
  placeholder?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  forceMulti?: boolean;
  showSearch?: boolean;
  filterOption?: boolean | ((inputValue: string, option: React.ReactElement) => boolean);
  notFoundContent?: React.ReactNode;
};

export const AntdSelect = (props: Props) => {
  function changeSelect(v: string) {
    props.setSelect?.(v);
  }
  const { Option } = Select;
  return props.selectOptions &&
    (props.selectOptions.length > 1 || props.forceMulti || props.placeholder) ? (
    <Select
      className={cx(
        style.antdSelect,
        props.isDarkColor ? style.darkColor : '',
        props.className || '',
      )}
      dropdownClassName={props.dropdownClassName}
      disabled={props.disabled}
      suffixIcon={<IconRcDropdown className={style.iDropdown} />}
      placeholder={props.placeholder}
      value={props.select}
      size={props.height === 32 ? 'default' : 'large'}
      style={{
        width: props.width || 160,
        height: props.height || 40,
        ...props.style,
      }}
      onChange={changeSelect}
      onSelect={props?.onSelect}
      showSearch={props.showSearch}
      notFoundContent={props.notFoundContent}
      filterOption={props.filterOption}>
      {props.selectOptions.map(v => (
        <Option
          key={v.mode}
          disabled={!!v.disabledTip}
          style={{
            height: props.height || 40,
            ...props.style,
          }}
          className={style.antdOptions}
          value={v.mode}>
          <HelperTooltip title={v.disabledTip} disable={!v.disabledTip}>
            {typeof v.label === 'string' ? (
              <span className={cx(v.disabledTip && style.isDisabled)}>{v.label}</span>
            ) : (
              v.label
            )}
            {v.disabledTip ? <img src={IconwarnMark} alt="" className={style.warnMark} /> : null}
          </HelperTooltip>
        </Option>
      ))}
    </Select>
  ) : (
    <div
      style={{ width: props.width || 160, height: props.height || 40 }}
      className={cx(
        style.antdSelect,
        props.isDarkColor ? style.darkColor : '',
        'ant-select',
        props.className || '',
        style.onlyOptions,
      )}>
      <div className={cx('ant-select-selection')}>{props.selectOptions[0]?.label || ''}</div>
    </div>
  );
};

export default AntdSelect;
